import { now } from "moment";
import IAction from "../../models/IAction";
import BaseReducer from "../../utilities/BaseReducer";
import IntegrationAction from "./IntegrationAction";
import IIntegrationState from "./models/IIntegrationState";
import IntegrationModel from "./models/IntegrationModel";
import SearchAnagCqCrmModel from "./models/SearchAnagCqCrmModel";
import ResultModel from "./models/ResultModel";

export default class IntegrationReducer extends BaseReducer<IIntegrationState> {
    public readonly initialState: IIntegrationState = {
        integration: new IntegrationModel({}),
        searchAnagCqCrm: new SearchAnagCqCrmModel({}),
        existsAnagOutOfVisibility: false,
    };

    public [IntegrationAction.REQUEST_INTEGRATION_FINISHED](
        state: IIntegrationState,
        action: IAction<IntegrationModel>
    ): IIntegrationState {
        console.log("action.payload:", action.payload!);
        return {
            ...state,
            integration: action.payload!,
        };
    }

    public [IntegrationAction.REQUEST_SEARCH_ANAG_CQCRM_FINISHED](
        state: IIntegrationState,
        action: IAction<SearchAnagCqCrmModel>
    ): IIntegrationState {
        return {
            ...state,
            searchAnagCqCrm: new SearchAnagCqCrmModel({
                data: action.payload!.data,
            }),
        };
    }

    public [IntegrationAction.REQUEST_SEARCH_ANAG_CQCRM_OUT_VISIBILITY_FINISHED](
        state: IIntegrationState,
        action: IAction<ResultModel>
    ): IIntegrationState {
        return {
            ...state,
            existsAnagOutOfVisibility: action.payload?.ok,
        };
    }
}
